import { UIElements } from '@ansvar-sakerhet/ui';
import { styled } from 'styled-components';

const ActionsContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

const IconButton = styled.button<{ $disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 4px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.35 : 1)};
`;

export const S = {
  ...UIElements,
  ActionsContainer,
  IconButton,
};
